import React from "react";
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

const Login = () => {
  return (
    <>
      <footer className="py-5">
        <Container>
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="6">
              <div className="copyright text-center text-xl-left text-muted">
                © {new Date().getFullYear()}{" "}
                <a
                  className="font-weight-bold ml-1"
                  href="/info"
                  target="_blank"
                  rel="noreferrer"
                >
                  Depact KJSIEIT
                </a>
              </div>
            </Col>
            <Col xl="6">
              <Nav className="nav-footer justify-content-center justify-content-xl-end">
                <NavItem>
                  <NavLink
                    href="#"
                  >
                    By
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                  >
                    Vivek
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                  >
                    Ashish
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                  >
                    Vighnesh
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Login;
